import React, { useEffect, useState } from "react";
import userServiceApi from "../../../api/userServiceApi";
import { postRequest } from "../../../api/http";
import "./Onboarding.scss";
import { getAuthToken, getRefreshToken, setAuthToken, setRefreshToken } from "../../../utils/helper";
import {
    getStripeAccountUrl,
    isStripeConnectOnboardingUrl,
} from "../../../utils/stripeOnboarding";

const Onboarding = () => {
    const [onboardingUrl, setOnboardingUrl] = useState(
        sessionStorage.getItem("stripeOnboardingUrl") || ""
    );
    const [loadingLink, setLoadingLink] = useState(false);

    useEffect(() => {
        const fetchStripeOnboardingUrl = async () => {
            const cachedUrl = sessionStorage.getItem("stripeOnboardingUrl");
            if (isStripeConnectOnboardingUrl(cachedUrl)) {
                setOnboardingUrl(cachedUrl);
                return;
            }

            const connectedAccountId = sessionStorage.getItem("connectedAccountId");
            if (!connectedAccountId) return;

            try {
                const stripeResponse = await postRequest(
                    userServiceApi.getStripeLink(connectedAccountId)
                );
                const url = getStripeAccountUrl(stripeResponse);
                if (url) {
                    sessionStorage.setItem("stripeOnboardingUrl", url);
                    setOnboardingUrl(url);
                }
            } catch (error) {
                console.log("Stripe onboarding link error----->", error);
            }
        };

        fetchStripeOnboardingUrl();
    }, []);

    const handleContinue = async () => {
        const connectedAccountId = sessionStorage.getItem("connectedAccountId");
        if (!connectedAccountId) return;

        setLoadingLink(true);
        let urlToOpen = onboardingUrl;

        try {
            const stripeResponse = await postRequest(
                userServiceApi.getStripeLink(connectedAccountId)
            );
            const freshUrl = getStripeAccountUrl(stripeResponse);
            if (freshUrl) {
                urlToOpen = freshUrl;
                sessionStorage.setItem("stripeOnboardingUrl", freshUrl);
                setOnboardingUrl(freshUrl);
            }
        } catch (error) {
            console.log("Stripe onboarding link error----->", error);
        } finally {
            setLoadingLink(false);
        }

        if (!isStripeConnectOnboardingUrl(urlToOpen)) return;

        const token = getAuthToken();
        const refresh = getRefreshToken();
        if (token) setAuthToken(token);
        if (refresh) setRefreshToken(refresh);
        window.open(urlToOpen, "_blank", "noopener,noreferrer");
    };

    return (
        <div className="onboarding-page">
            <div className="onboarding-container">
                <div className="onboarding-icon">
                    <span>✓</span>
                </div>

                <h1>Stripe Account Created Successfully!</h1>

                <p className="onboarding-mandatory-message">
                    Onboarding is mandatory. Please complete it to access the application.
                </p>

                <p className="onboarding-description">
                    To continue with the onboarding process, please click the link below
                    to complete your Stripe account setup.
                </p>



                <button
                    type="button"
                    className="onboarding-button"
                    onClick={handleContinue}
                    disabled={
                        loadingLink ||
                        !sessionStorage.getItem("connectedAccountId")
                    }
                >
                    {loadingLink ? "Loading..." : "Continue Onboarding"}
                </button>

                <p className="onboarding-link-text">
                    You will be redirected to Stripe to complete the remaining steps.
                </p>
            </div>
        </div>
    );
};

export default Onboarding;
